import type { NextPage } from 'next'

import { duplicateBill } from 'data/seo'
import DuplicateBill from 'src/presentation/views/duplicate-bill'

const DuplicateBillPage: NextPage = () => <DuplicateBill />

export default DuplicateBillPage

export async function getStaticProps() {
  return {
    props: { SEO: duplicateBill }
  }
}
